import React, { ComponentProps } from 'react'
import truncate from 'lodash/truncate'
import { Icon, l } from '@manychat/manyui'

import { AttachmentComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/AttachmentComponent/AttachmentComponent'
import { AttachmentAppearance } from 'common/builder/components/chart/FlowChart/types/AttachmentAppearance'

interface DynamicImagePreviewProps {
  url: string
  maxChars?: number
  style?: React.CSSProperties
  containerProps?: Partial<ComponentProps<typeof AttachmentComponent>['containerProps']>
}

export const DynamicImagePreview = React.memo(
  ({ url, maxChars = 150, containerProps }: DynamicImagePreviewProps) => {
    const imgUrlText = url ? truncate(url, { length: maxChars }) : l.translate('Click to edit URL')

    return (
      <AttachmentComponent
        attachment={{
          icon: Icon.Image,
          title: imgUrlText,
          appearance: AttachmentAppearance.EXTERNAL,
        }}
        containerProps={containerProps}
      />
    )
  },
)
